import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { useIsModifierAvailable } from 'src/modules/checkout/composables/sales-availability/modifiers/IsModifierAvailable'
import { toValue } from 'vue'

// Options is a hash containing fields that can be used to validate modifier set availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

export function useIsItemModifierSetAvailable () {
  const { isModifierAvailable } = useIsModifierAvailable()

  function isItemModifierSetAvailable (itemModifierSet, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    const itemModifierSetValue = toValue(itemModifierSet)

    if (_.isNil(itemModifierSetValue)) return false

    const salesChannelValue = toValue(salesChannel)
    const orderItemValue = toValue(orderItem)

    // The Item Modifier Set's Modifier Set must be active (not archived) to be presented
    if (itemModifierSetValue.modifierSet.archivable && !itemModifierSetValue.modifierSet.isActive) return false

    // The Item Modifier Set's Modifier Set must be available on the current Sales Channel
    if (!itemModifierSetValue.modifierSet.isSalesChannelEnabled(salesChannelValue)) return false

    // If the Sales Channel is private, the Item Modifier Set is available, regardless of
    // Inventory or Sales Toggle (the Item Modifier Set may be shown without being selectable)
    if (_.includes(SALES_CHANNEL_TYPES.PRIVATE, salesChannelValue)) return true

    // If the Item Modifier Set has no minimum selection count, it is available
    if (!_.isInteger(itemModifierSetValue.minSelectionCount) || itemModifierSetValue.minSelectionCount === 0) return true

    let availableModifierCount = 0
    const options = {
      salesChannel: salesChannelValue,
      orderItem: orderItemValue
    }

    for (const modifier of itemModifierSetValue.modifierSet.modifiers.data) {
      if (isModifierAvailable(modifier, options)) {
        availableModifierCount++
      }

      if (availableModifierCount >= itemModifierSetValue.minSelectionCount) {
        break
      }
    }

    if (availableModifierCount < itemModifierSetValue.minSelectionCount) return false

    return true
  }

  return {
    isItemModifierSetAvailable
  }
}
